import React from "react";

const Login = () => {
  return (
    <div
      onClick={() => {
        console.log("!!");
        window.location.href = "/bff";
      }}
    >
      <h2>Login Page</h2>
    </div>
  );
};

export default Login;
